import { Box, type BoxProps } from "@chakra-ui/react";

export function NeonDieMark(props: BoxProps) {
  return (
    <Box
      as="svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      flex="0 0 auto"
      {...props}
    >
      <defs>
        <linearGradient id="nvp-die-cube" x1="9" y1="8" x2="55" y2="58">
          <stop offset="0" stopColor="#37d5ff" />
          <stop offset="0.48" stopColor="#9b5cff" />
          <stop offset="1" stopColor="#ff4fd8" />
        </linearGradient>
        <filter id="nvp-die-glow" x="-35%" y="-35%" width="170%" height="170%">
          <feGaussianBlur stdDeviation="3.4" result="blur" />
          <feColorMatrix
            in="blur"
            type="matrix"
            values="0 0 0 0 0.9 0 0 0 0 0.2 0 0 0 0 1 0 0 0 0.75 0"
          />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g filter="url(#nvp-die-glow)" transform="rotate(9 32 32)">
        <rect
          x="12"
          y="10"
          width="40"
          height="40"
          rx="9"
          fill="url(#nvp-die-cube)"
          stroke="#e8fbff"
          strokeOpacity="0.7"
          strokeWidth="1.6"
        />
        <rect
          x="22"
          y="20"
          width="20"
          height="20"
          rx="2.5"
          fill="none"
          stroke="#ffffff"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <circle cx="27.5" cy="25.5" r="1.9" fill="#ffffff" />
        <circle cx="36.5" cy="25.5" r="1.9" fill="#ffffff" />
        <circle cx="32" cy="32" r="1.9" fill="#ffffff" />
        <circle cx="27.5" cy="38.5" r="1.9" fill="#ffffff" />
        <circle cx="36.5" cy="38.5" r="1.9" fill="#ffffff" />
      </g>
    </Box>
  );
}
